<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 13 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.07772 10.5604C2.05944 12.5979 3.73576 14.2955 6.23803 15.9316C6.37768 16.0228 6.62232 16.0228 6.76197 15.9316C9.26424 14.2955 10.9406 12.5979 11.9223 10.5604C12.904 8.52254 13.1826 6.15997 12.8893 3.19384C12.8659 2.95685 12.6916 2.79557 12.4638 2.76386C10.0582 2.44893 8.57819 1.88889 6.83644 0.13921C6.65259 -0.0464033 6.34741 -0.0464033 6.16356 0.13921C4.42181 1.88889 2.94179 2.44893 0.536203 2.76386C0.308413 2.79557 0.134091 2.95685 0.110653 3.19384C-0.182568 6.15997 0.0960045 8.52254 1.07772 10.5604Z" fill="url(#paint0_linear_shield)"/>
    <defs>
      <linearGradient id="paint0_linear_shield" gradientUnits="userSpaceOnUse" x1="0.512806" x2="13.4064" y1="0.516372" y2="11.2722">
        <stop :stop-color="fill"/>
        <stop offset="0.536458" :stop-color="fill" stop-opacity="0.7"/>
        <stop offset="0.989583" :stop-color="fill"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Shield',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
